import { normalizeText, splitText } from "@flixbus-phx/marketplace-common";
import * as React from "react";

const highlightText = (text: string, searchValue?: string, highlightClass?: string): JSX.Element | string => {
  if (!searchValue?.trim()) {
    return text;
  }

  const normalizedSearchValue = normalizeText(searchValue);
  const searchWords = searchValue.includes(" ") ? splitText(normalizedSearchValue) : [normalizedSearchValue];

  if (searchWords.length === 0) {
    return text;
  }

  const normalizedText = normalizeText(text);

  // Create regex pattern that matches any of the search words (supports partial matching)
  // Escape special regex characters
  const pattern = searchWords.map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");
  const regex = new RegExp(`(${pattern})`, "gi");

  const parts = normalizedText.split(regex);

  if (parts.length <= 1) {
    return text;
  }

  let indexStart = 0;

  return (
    <span>
      {parts.map((part, i) => {
        const indexEnd = indexStart + part.length;
        const textPart = text.slice(indexStart, indexEnd);

        indexStart = indexEnd;

        const isMatch = searchWords.some((searchWord) => part === searchWord);

        if (isMatch) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <mark key={i} className={highlightClass}>
              {textPart}
            </mark>
          );
        }

        return textPart;
      })}
    </span>
  );
};

export default highlightText;
